import React from 'react';
import { Flex, Text } from '@amzn/storm-ui';
import { useAccountDropdownBundle } from 'src/providers/PantherLocalizationProvider';

export const NoAccountsMessage: React.VFC = () => {
  const bundle = useAccountDropdownBundle();

  return (
    <Flex
      justifyContent="center"
      paddingBlockStart="xsmall"
      paddingBlockEnd="xsmall"
      paddingInlineStart="base"
      paddingInlineEnd="base"
    >
      <Text color="tertiary" size="xsmall">
        {bundle.getMessage('account-dropdown-no-accounts-found')}
      </Text>
    </Flex>
  );
};
